module.exports = __webpack_public_path__ + "fonts/fa-brands-400---273dc9bf9778fd37fa61357645d46a28.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/fontawesome-free/webfonts/fa-brands-400.ttf
// module id = 375
// module chunks = 0